import { NORWEGIAN } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Norwegian
const NDSection: Section[] = [
  {
    name: '1: Referanse og oversikt',
    subSections: [
      {
        name: 'Forord',
        page: 3,
      },
      {
        name: 'Formål og bruksområder for feltveiledning',
        page: 4,
      },
      {
        name: 'Viktige definisjoner',
        page: 5,
      },
      {
        name: 'Kontrollhierarki',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFEsavers',
    subSections: [
      {
        name: 'Motorkjøretøy – Trafikksikkerhet',
        page: 9,
      },
      {
        name: 'Arbeid i høyden',
        page: 12,
      },
      {
        name: 'Mobilt utstyr (MU)',
        page: 18,
      },
      {
        name: 'Lockout Tagout / Energiisolering',
        page: 22,
      },
      {
        name: 'Elektrisk arbeid',
        page: 25,
      },
      {
        name: 'Trangt rom',
        page: 29,
      },
      {
        name: 'Bulkmateriale og lagring',
        page: 32,
      },
      {
        name: 'Sikkerhet for togvogner',
        page: 37,
      },
      {
        name: 'Arbeid med utgravinger og grøfter',
        page: 41,
      },
      {
        name: 'Løfting og rigging',
        page: 45,
      },
      {
        name: 'Farlige stoffer',
        page: 49,
      },
      {
        name: 'Varmt arbeid',
        page: 52,
      },
    ],
  },
  {
    name: '3: Ytterligere ressurser og verktøy',
    subSections: [
      {
        name: 'Arbeid over og rundt vann',
        page: 56,
      },
      {
        name: 'Mistede eller fallende gjenstander',
        page: 59,
      },
      {
        name: 'Atmosfære-/gasstesting',
        page: 61,
      },
      {
        name: 'Kommunikasjon ved kjemisk fare',
        page: 65,
      },
    ],
  },
  {
    name: '4: Cargills sikkerhetsstyringspraksis',
    subSections: [
      {
        name: 'Nøkkelterminologi',
        page: 70,
      },
      {
        name: 'Fastsettelse av hendelse med alvorlig personskade og dødsfall (SIF)',
        page: 72,
      },
      {
        name: 'Kategorisering av potensial for alvorlig personskade og dødsfall (SIFp)',
        page: 73,
      },
      {
        name: 'Tabell for automatisk fastsettelse for SIF-kriterier',
        page: 74,
      },
      {
        name: 'Menneskelig og organisatorisk ytelse (HOP)',
        page: 76,
      },
    ],
  },
];
const NDTableOfContent: TableOfContent = {
  language: 'nb',
  sections: NDSection,
  label: 'Innholdsfortegnelse',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Safety Guide NORWEGIAN_DIGITAL_CROPPED.pdf',
  hopPocket: 'HOP-lommeguide',
  hopPocketLink:
    'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Norwegian (Bokmal).pdf',
  source: NORWEGIAN,
};

export default NDTableOfContent;
